import React from "react";
import BottomNavigation from "../components/bottom-navigation/bottom-navigation.component";
import clsx from "clsx";
import { BaseIcon } from "../components/base-icon/base-icon.component";
import { useBackHandler } from "../hooks/use-back-handler.hook";

function WithBackBtnLayout({ hasBottomNavigation, pageTitle, onBack, children }) {
	const { manualBack } = useBackHandler();

	return (
		<div className="d-flex flex-column h-100">
			<div className="d-flex justify-content-center w-100">
				<div className="fixed-top d-flex justify-content-center">
					<div className="fixed-elements-container">
						<div className="d-flex align-items-center py-150">
							<span onClick={onBack ?? manualBack}>
								<BaseIcon
									name="ArrowRight"
									color="#000"
									size={24}
									strokeWidth={1}
									className="p-50 me-50 with-back-button-layout-back-button"
								/>
							</span>
							<span className="f-12 fw-600 me-25">{pageTitle}</span>
						</div>
					</div>
				</div>
			</div>

			<div
				className={clsx("content-with-back-bottom h-100", {
					"content-with-bottom-navigation": hasBottomNavigation,
				})}
			>
				{children}
			</div>

			{hasBottomNavigation && (
				<div className="bottom-navigation-menu-holder">
					<BottomNavigation />
				</div>
			)}
		</div>
	);
}

export default WithBackBtnLayout;
